import { Box } from '@/components/Box/Box';
import { IconButton } from '@/components/IconButton/IconButton';
import IncrementIcon from '@/images/IncrementIcon.svg?react';
import DashIcon from '@/images/DashIcon.svg?react';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { MAX_OVERAGE_WIRE_COUNT, MIN_OVERAGE_WIRE_COUNT } from '../const/const';
import { CountBlock } from './styles';

type OverageWiresCounterType = {
  onIncrement: () => void;
  onDecrement: () => void;
  count: number;
};

export const OverageWiresCounter = ({ onIncrement, onDecrement, count }: OverageWiresCounterType) => {
  const decrementDisabled = count === MIN_OVERAGE_WIRE_COUNT;
  const incrementDisabled = count === MAX_OVERAGE_WIRE_COUNT;

  return (
    <Box display='flex' alignItems='center' justifyContent='space-between' columnGap='8px'>
      <IconButton
        width='50px'
        height='50px'
        flexShrink={0}
        onClick={onDecrement}
        svgPath='stroke'
        disabled={decrementDisabled}
      >
        <DashIcon />
      </IconButton>
      <CountBlock>
        <Typography variant='headline4' fontWeight='semibold' color={COLORS.black}>
          {count}
        </Typography>
      </CountBlock>
      <IconButton
        width='50px'
        height='50px'
        flexShrink={0}
        onClick={onIncrement}
        svgPath='stroke'
        disabled={incrementDisabled}
      >
        <IncrementIcon />
      </IconButton>
    </Box>
  );
};
